export class UserSettingAdminViewModel {
    userSettingViewModels: UserSettingViewModel[];
}

export class UserSettingViewModel {
    id: number;
    userSettingKeyID: number;
    userSettingKeyName: string;
    customUserSettingValue: string;
    defaultUserSettingValue: string;
    createdDate: Date;

    constructor(props: { [key in keyof UserSettingViewModel]?: UserSettingViewModel[key] }) {
        Object.assign(this, {
            ...props
        });
    }
}